import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateSampling, UpdateSamplingPayload } from '../api/updateSampling';

export const useUpdateSampling = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name, id, productId }: UpdateSamplingPayload) => {
      return await updateSampling({ name, id, productId });
    },
    onSuccess: async (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['product-samplings', variables.productId]
      });
    }
  });
};
